// Mock data for Sportiva Infotech - IT Services Website

export const companyInfo = {
  name: "Sportiva Infotech",
  tagline: "Transform Your Vision into Scalable Digital Solutions",
  description: "India-based IT services & technology consulting company delivering world-class digital solutions to global clients. We partner with startups, SMEs, and enterprises to build high-performance applications.",
  location: "48, Yamuna Industrial Estate V-2, Near Chirag Estate, On Canal, C.T.M, Amraiwadi, Ahmedabad, Gujarat – 380026",
  copyrightName: "SPORTIVA INFOTECH PRIVATE LIMITED (Formerly known as GAMESYS FANTASY PRIVATE LIMITED)",
  socials: {
    linkedin: "https://www.linkedin.com/company/sportiva-infotech-private-limited/"
  }
};

export const navLinks = [
  { label: "About", href: "#about" },
  { label: "Team", href: "#team" },
  { label: "Services", href: "#services" },
  { label: "Industries", href: "#industries" },
  { label: "Engagement Models", href: "#engagement" },
  { label: "Why Us", href: "#why-us" },
  { label: "Contact", href: "#contact" }
];

export const heroContent = {
  headline: "Transform Your Vision into Scalable Digital Solutions",
  subheadline: "We help startups, SMEs, and enterprises design, build, and scale high-performance web, mobile, and cloud applications—delivered globally from India.",
  primaryCTA: "Schedule a Free Consultation",
  secondaryCTA: "View Our Services",
  valueProps: [
    { title: "Global Delivery", description: "US-aligned communication with India-based execution" },
    { title: "End-to-End Expertise", description: "From ideation to deployment and beyond" },
    { title: "Agile Teams", description: "Flexible, sprint-based delivery methodology" },
    { title: "Security First", description: "Enterprise-grade security at every layer" }
  ]
};

export const aboutContent = {
  title: "About Us",
  subtitle: "Your Trusted Technology Partner",
  description: "Sportiva Infotech is an India-based IT services and technology consulting company with a global delivery model. We specialize in helping businesses across the US, Europe, and APAC transform their digital presence.",
  mission: "To empower businesses worldwide with innovative, scalable, and secure technology solutions that drive measurable growth.",
  vision: "To be the most trusted technology partner for businesses seeking digital transformation excellence.",
  values: [
    {
      title: "Engineering Excellence",
      description: "We believe in writing clean, maintainable code that stands the test of time."
    },
    {
      title: "Transparency",
      description: "Open communication, honest timelines, and clear expectations at every stage."
    },
    {
      title: "Ownership",
      description: "We treat every project as our own, taking full accountability for outcomes."
    },
    {
      title: "Long-term Partnership",
      description: "We build relationships, not just projects. Your success is our success."
    }
  ]
};

export const teamContent = {
  title: "Our Team",
  subtitle: "Experienced Engineers, Designers & Product Leaders",
  description: "Our team comprises senior engineers, product strategists, and design experts who bring decades of combined experience across diverse industries and technologies.",
  philosophy: "We believe in ownership, accountability, and continuous improvement. Every team member is empowered to make decisions and drive results.",
  departments: [
    { name: "Engineering", description: "Full-stack developers, architects, and specialists" },
    { name: "Product", description: "Product managers and business analysts" },
    { name: "Design", description: "UI/UX designers and researchers" },
    { name: "Cloud & DevOps", description: "Infrastructure and deployment experts" },
    { name: "Quality Assurance", description: "QA engineers and automation specialists" }
  ],
  leadership: []
};

export const services = [
  {
    id: 1,
    title: "Web Application Development",
    shortDesc: "Custom web applications built for performance, scalability, and user experience.",
    description: "We build robust, scalable web applications using modern frameworks and cloud-native architectures. From MVPs to enterprise platforms, we deliver solutions that grow with your business.",
    icon: "Globe",
    capabilities: ["Single Page Applications", "Progressive Web Apps", "Enterprise Portals", "SaaS Platforms", "API Development"],
    technologies: ["React", "Angular", "Vue.js", "Node.js", "Python", "PostgreSQL"],
    cta: "Build Your Platform"
  },
  {
    id: 2,
    title: "Mobile App Development",
    shortDesc: "Native and cross-platform mobile apps that users love and businesses rely on.",
    description: "Create engaging mobile experiences with our expert mobile development team. We build apps that perform flawlessly across iOS and Android platforms.",
    icon: "Smartphone",
    capabilities: ["iOS Development", "Android Development", "Cross-Platform Apps", "App Store Optimization", "Mobile Backend"],
    technologies: ["Flutter", "React Native", "Swift", "Kotlin", "Firebase"],
    cta: "Launch Your App"
  },
  {
    id: 3,
    title: "Cloud & DevOps",
    shortDesc: "Scalable cloud infrastructure with automated CI/CD pipelines.",
    description: "Leverage the power of cloud computing with our DevOps expertise. We design, implement, and manage cloud infrastructure that scales automatically and reduces costs.",
    icon: "Cloud",
    capabilities: ["Cloud Migration", "Infrastructure as Code", "CI/CD Pipelines", "Container Orchestration", "Monitoring & Logging"],
    technologies: ["AWS", "Azure", "Google Cloud", "Docker", "Kubernetes", "Terraform"],
    cta: "Scale Your Infrastructure"
  },
  {
    id: 4,
    title: "UI/UX Design",
    shortDesc: "User-centered design that drives engagement and conversions.",
    description: "Create memorable digital experiences with our design team. We combine user research, visual design, and interaction design to build products users love.",
    icon: "Palette",
    capabilities: ["User Research", "Wireframing", "Visual Design", "Prototyping", "Design Systems"],
    technologies: ["Figma", "Adobe XD", "Sketch", "InVision", "Principle"],
    cta: "Design Your Experience"
  },
  {
    id: 5,
    title: "Product Engineering",
    shortDesc: "End-to-end product development from ideation to launch and beyond.",
    description: "Transform your product vision into reality with our full-cycle product engineering services. We handle everything from concept validation to market launch.",
    icon: "Rocket",
    capabilities: ["Product Strategy", "MVP Development", "Agile Development", "Product Scaling", "Technical Consulting"],
    technologies: ["Full Stack", "Microservices", "Event-Driven", "Serverless"],
    cta: "Build Your Product"
  },
  {
    id: 6,
    title: "Dedicated Development Teams",
    shortDesc: "Extend your team with skilled engineers who integrate seamlessly.",
    description: "Scale your development capacity with our dedicated team model. Get access to vetted, experienced developers who work as an extension of your in-house team.",
    icon: "Users",
    capabilities: ["Team Augmentation", "Managed Teams", "Remote Development", "Technical Leadership", "Knowledge Transfer"],
    technologies: ["Any Stack", "Your Tools", "Your Processes"],
    cta: "Build Your Team"
  }
];

export const industries = [
  { 
    name: "Startups & SaaS", 
    icon: "Rocket",
    description: "MVP development, rapid iteration, and scalable architecture for growth-stage companies."
  },
  { 
    name: "FinTech & Payments", 
    icon: "CreditCard",
    description: "Secure, compliant financial applications with robust transaction processing."
  },
  { 
    name: "SportsTech & Gaming", 
    icon: "Trophy",
    description: "Real-time applications, live data processing, and engaging user experiences."
  },
  { 
    name: "Healthcare", 
    icon: "Heart",
    description: "HIPAA-compliant solutions for patient care, telemedicine, and health data management."
  },
  { 
    name: "E-commerce", 
    icon: "ShoppingCart",
    description: "Scalable online stores with seamless checkout and inventory management."
  },
  { 
    name: "Enterprise Solutions", 
    icon: "Building",
    description: "Custom enterprise applications, integrations, and digital transformation."
  }
];

export const engagementModels = [
  {
    title: "Fixed Price",
    description: "Best for well-defined projects with clear requirements and scope.",
    features: [
      "Detailed project scoping upfront",
      "Fixed timeline and budget",
      "Milestone-based payments",
      "Clear deliverables"
    ],
    bestFor: "MVPs, redesigns, specific features"
  },
  {
    title: "Time & Material",
    description: "Ideal for evolving projects where requirements may change.",
    features: [
      "Flexible scope and priorities",
      "Pay for actual hours worked",
      "Sprint-based delivery",
      "Regular progress updates"
    ],
    bestFor: "Ongoing development, complex projects"
  },
  {
    title: "Dedicated Teams",
    description: "Perfect for long-term partnerships requiring consistent resources.",
    features: [
      "Full-time dedicated developers",
      "Direct team management",
      "Seamless integration",
      "Knowledge retention"
    ],
    bestFor: "Product companies, scaling teams"
  }
];

export const whyChooseUs = [
  {
    title: "India Cost Advantage, Global Quality",
    description: "Access world-class talent at competitive rates without compromising on quality or communication standards.",
    icon: "Globe"
  },
  {
    title: "Clear Communication & Accountability",
    description: "US-aligned working hours, proactive updates, and a single point of contact for all your needs.",
    icon: "MessageSquare"
  },
  {
    title: "Agile, DevOps-Driven Delivery",
    description: "Sprint-based development with continuous integration ensures rapid, reliable releases.",
    icon: "Zap"
  },
  {
    title: "Security & Scalability Focus",
    description: "Enterprise-grade security practices and cloud-native architectures built for growth.",
    icon: "Shield"
  },
  {
    title: "Long-term Partnership Approach",
    description: "We invest in understanding your business deeply, becoming a true extension of your team.",
    icon: "Handshake"
  },
  {
    title: "Senior Engineering Oversight",
    description: "Every project is guided by experienced architects and tech leads who ensure quality.",
    icon: "Award"
  }
];

export const caseStudies = [
  {
    id: 1,
    title: "FinTech Payment Platform",
    challenge: "A US-based FinTech startup needed to build a secure, PCI-compliant payment processing platform from scratch.",
    solution: "Built a microservices-based payment platform with real-time transaction processing, fraud detection, and comprehensive reporting.",
    technologies: ["Node.js", "React", "PostgreSQL", "AWS", "Redis"],
    outcome: "Processing $2M+ monthly transactions with 99.99% uptime",
    industry: "FinTech"
  },
  {
    id: 2,
    title: "Healthcare Telemedicine App",
    challenge: "A healthcare provider needed a HIPAA-compliant telemedicine solution to serve patients remotely.",
    solution: "Developed a cross-platform mobile app with video consultations, appointment scheduling, and secure health record access.",
    technologies: ["Flutter", "Python", "Firebase", "WebRTC", "Azure"],
    outcome: "50,000+ consultations completed, 4.8★ app rating",
    industry: "Healthcare"
  },
  {
    id: 3,
    title: "E-commerce Marketplace",
    challenge: "A retail brand wanted to launch a multi-vendor marketplace with complex inventory and logistics integration.",
    solution: "Built a scalable marketplace platform with vendor management, real-time inventory, and multiple payment gateways.",
    technologies: ["React", "Node.js", "MongoDB", "Elasticsearch", "AWS"],
    outcome: "200+ vendors onboarded, 3x revenue growth in 6 months",
    industry: "E-commerce"
  }
];

export const contactContent = {
  title: "Let's Build Something Great Together",
  subtitle: "Ready to transform your idea into reality? Share your project details and we'll get back to you within 24 hours.",
  consultationCTA: "Schedule a Free Consultation",
  estimateCTA: "Get a Project Estimate"
};

export const footerLinks = {
  services: [
    { label: "Web Development", href: "#services" },
    { label: "Mobile Apps", href: "#services" },
    { label: "Cloud & DevOps", href: "#services" },
    { label: "UI/UX Design", href: "#services" },
    { label: "Product Engineering", href: "#services" }
  ],
  industries: [
    { label: "Startups & SaaS", href: "#industries" },
    { label: "FinTech", href: "#industries" },
    { label: "Healthcare", href: "#industries" },
    { label: "E-commerce", href: "#industries" }
  ],
  company: [
    { label: "About Us", href: "#about" },
    { label: "Our Team", href: "#team" },
    { label: "Why Choose Us", href: "#why-us" },
    { label: "Contact", href: "#contact" }
  ],
  legal: [
    { label: "Privacy Policy", href: "#" },
    { label: "Terms of Service", href: "#" }
  ]
};
